import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when IS_TOKEN_LIMITS_ENABLED is set to "true" on the
// server. Controls whether the Usage Limits tab is surfaced — enforcement
// itself happens server-side regardless of what the UI shows.
export const useTokenLimitsEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.features.isTokenLimitsEnabled ?? false;
};
